<template>
  <template v-if="isAdminEfp">
    <ActionButton
      label="Couleur liée"
      variant="info"
      @click="handleLinkColors"
      :disabled="selectedCount === 0"
      :title="buttonTitle"
      size="sm"
      customClass="!text-[10px] !px-1.5 !py-0.5 !min-h-0 !h-6 !w-auto min-[976px]:whitespace-nowrap w-full !mr-0"
    />

    <ActionButton
      label="Couleur déliée"
      variant="modifier"
      @click="handleDelinkColors"
      :disabled="selectedCount === 0"
      :showIcon="false"
      :title="buttonTitle"
      size="sm"
      customClass="!text-[10px] !px-1.5 !py-0.5 !min-h-0 !h-6 !w-auto min-[976px]:whitespace-nowrap w-full !mr-0"
    />
  </template>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import ActionButton from '@/components/ui/ActionButton.vue'
import { adminEfpImpersonationStatus } from '@/api/adminEfp'
import { useAdminEfpStore } from '@/stores/adminEfp'
import { useAuthStore } from '@/stores/auth'

interface Props {
  selectedCount: number
}

interface Emits {
  (e: 'link-colors-selected'): void
  (e: 'delink-colors-selected'): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const adminEfpStore = useAdminEfpStore()
const authStore = useAuthStore()

const isAdminEfp = computed(
  () => adminEfpStore.isAdminEfpValidated || authStore.isImpersonating,
)

const buttonTitle = computed(() =>
  props.selectedCount === 0
    ? 'Sélectionnez des produits pour activer cette action'
    : undefined,
)

onMounted(async () => {
  if (isAdminEfp.value) return
  try {
    const status = await adminEfpImpersonationStatus()
    authStore.setImpersonationFromCookie(
      status.active,
      status.adminDisplayName ?? undefined,
    )
  } catch {
    authStore.setImpersonationFromCookie(false)
  }
})

const handleLinkColors = () => {
  if (!props.selectedCount) return
  emit('link-colors-selected')
}

const handleDelinkColors = () => {
  if (!props.selectedCount) return
  emit('delink-colors-selected')
}
</script>
